var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('record-choose-item',{attrs:{"className":'choose-record-choose-item',"recordData":_vm.source,"itemFunc":_vm.chooseRecordChooseItem}})}
var staticRenderFns = []

export { render, staticRenderFns }